// src/components/settings/settings-panel.ts
import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'
import { getSettingsController, updateThemeSetting } from './settings-controller'

@customElement('settings-panel')
export class SettingsPanel extends LitElement {
    static styles = css`
        :host {
            display: block;
            padding: var(--s1);
        }

        .setting-group {
            margin-bottom: var(--s2);
        }

        .setting-label {
            display: block;
            margin-bottom: var(--s-1);
            font-weight: 500;
        }
    `

    private getThemeValue() {
        const controller = getSettingsController()
        return controller?.settings.theme || 'system'
    }

    private handleThemeChange(e: { detail: { value: any } }) {
        updateThemeSetting(e.detail.value)
    }

    render() {
        const themeOptions = [
            { value: 'light', label: 'Light Theme' },
            { value: 'dark', label: 'Dark Theme' },
            { value: 'system', label: 'System Default' },
        ]

        return html`
            <div class="setting-group">
                <span class="setting-label">Theme</span>
                <e-select
                    .options="${themeOptions}"
                    .value="${this.getThemeValue()}"
                    @value-changed="${this.handleThemeChange}"
                    fullWidth
                ></e-select>
            </div>

            <!-- Additional settings can be added here -->
        `
    }
}
